import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { ConsumerAdminService } from "../../../services/api/consumer-admin.service";
import { ConsumerAdminActions } from "../../actions/consumer-admin.actions";
import { FailState } from "../../models/fail-state";
import { UsersState } from "../../models/users-state";
import { AppState } from "../../reducers";
import { UsersSelectors } from "../../selectors/users.selectors";

@Injectable()
export class ConsumerUsersGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerAdminActions.users.get),
			withLatestFrom(this.store.select(UsersSelectors.users)),
			switchMap(([, state]) =>
				this.canUserStoreValue(state)
					? of(ConsumerAdminActions.users.getSuccess(state))
					: of(ConsumerAdminActions.users.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(
				ConsumerAdminActions.users.getApi,
				ConsumerAdminActions.user.createSuccess,
				ConsumerAdminActions.userRoles.updateSuccess
			),
			switchMap(() =>
				this.consumerAdminService.users().pipe(
					map((users) =>
						ConsumerAdminActions.users.getSuccess({ users, loading: false })
					),
					catchError((error) =>
						of(ConsumerAdminActions.users.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private store: Store<AppState>,
		private consumerAdminService: ConsumerAdminService
	) {}

	private canUserStoreValue(state: UsersState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
